export const ERROR_GENERIC_API_ERROR = 'We have encountered an uknown error. Please try again in a minute.'
